import React, { Component } from 'react';
import { Card, message } from 'antd';
import Process from '@comm/workflow/Process';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import { browserHistory } from 'react-router';

import {
  queryDeletePurchase,
  queryPurchaseWorkflow,
  querySavePurchase,
} from '@api/administrative/purchase';
import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
    };
  }

  componentDidMount() {
    this.purchaseWorkflow();
  }

  /**
   * 提交采购
   */
  handSubmit = item => {
    this.savePurchase(item);
  };

  purchaseWorkflow = params => {
    const { instance } = this.state;
    queryPurchaseWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  /**
   * 保存
   */
  savePurchase = item => {
    this.setState({
      isSubmitting: true,
    });
    querySavePurchase(item).then(res => {
      this.setState({
        isSubmitting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  deletePurchase = () => {
    queryDeletePurchase({
      uuid: this.props.data.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { isSubmitting, instance } = this.state;
    const dataInfo = this.props.data;
    const histories = dataInfo.histories || [];
    return (
      <div>
        <FormBase
          data={dataInfo}
          handSubmit={this.handSubmit}
          handleDelete={this.deletePurchase}
          isSubmitting={isSubmitting}
          {...this.props}
        />
        <Card>
          <Process instance={instance} />
          <div style={{ marginTop: '16px' }}>
            <ProcessHistory dataSource={histories} />
          </div>
        </Card>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/administrative/purchase/PageEdit.js